export default __webpack_public_path__ + "static/media/sterv-nati-engagement-photo.1ad3c73e.jpg";